import { useState } from "react";
import { PenLine, Trash2 } from "lucide-react";
import SignatureSheet from "@/components/legal/SignatureSheet";
import { Panel } from "./shared";

export const SignPanel = ({ sigData, onCapture, onClearSig, fieldCount, onClearFields }) => {
  const [sheetOpen, setSheetOpen] = useState(false);
  return (
    <Panel testid="sign-controls">
      <div className="border border-hairline rounded-lg bg-page p-3">
        <div className="flex items-center justify-between gap-3 flex-wrap">
          {sigData ? (
            <span className="flex items-center gap-3 min-w-0" data-testid="sign-signature-chip">
              <img src={sigData.b64} alt={`Signature of ${sigData.name}`} className="h-9 w-auto rounded-sm border border-hairline bg-white px-2 py-1" />
              <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-fog truncate">Signing as {sigData.name}</span>
            </span>
          ) : (
            <p className="font-mono text-[10px] leading-relaxed text-fog">
              Capture your signature once, then draw boxes on the page previews to place it.
            </p>
          )}
          <span className="flex items-center gap-2 shrink-0">
            {sigData ? (
              <>
                <button type="button" data-testid="sign-change-signature" onClick={() => setSheetOpen(true)}
                  className="border border-hairline rounded-full px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-fog hover:text-ink hover:border-ink transition-colors duration-300">
                  Change
                </button>
                <button type="button" data-testid="sign-clear-signature" onClick={onClearSig}
                  className="border border-hairline rounded-full px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-mist hover:text-[#FF3333] hover:border-[#FF3333]/40 transition-colors duration-300">
                  Clear
                </button>
              </>
            ) : (
              <button type="button" data-testid="sign-add-signature" onClick={() => setSheetOpen(true)}
                className="flex items-center gap-1.5 v4-btn-primary rounded-full px-4 py-2 font-mono text-[10px] uppercase tracking-[0.15em] transition-colors duration-300">
                <PenLine className="w-3.5 h-3.5" strokeWidth={1.5} /> Add signature
              </button>
            )}
            {fieldCount > 0 && (
              <button type="button" data-testid="sign-clear-fields" onClick={onClearFields}
                className="flex items-center gap-1.5 border border-hairline rounded-full px-3 py-1.5 font-mono text-[10px] uppercase tracking-[0.15em] text-mist hover:text-[#FF3333] hover:border-[#FF3333]/40 transition-colors duration-300">
                <Trash2 className="w-3.5 h-3.5" strokeWidth={1.5} /> {fieldCount} box{fieldCount === 1 ? "" : "es"}
              </button>
            )}
          </span>
        </div>
      </div>
      <SignatureSheet
        open={sheetOpen}
        onClose={() => setSheetOpen(false)}
        onSubmit={(data) => { onCapture({ name: data.name, b64: data.signature_b64 }); setSheetOpen(false); }}
        busy={false}
      />
    </Panel>
  );
};
